import { Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import { Filter, CheckSquare, Square, FileText, Download } from 'react-feather';
import colors from '../../../theme/colors';

function AccionesActa({
  data,
  isActa,
  isLoading,
  fecha,
  listadoAlumnos,
  alumnosIds,
  activities,
  allChecked,
  handleProceeding,
  handleCheck,
  handleGenerate,
  handleImport,
  importMode,
}) {
  if (data === '') return null;

  const canGenerateActa =
    alumnosIds.length > 0 &&
    data.groups.length > 0 &&
    activities.length > 0 &&
    !isLoading;
  const canImport = alumnosIds.length > 0 && data.groups.length > 0 && !isLoading;
  const canFiltrarActa = fecha !== '' && data.groups.length > 0;
  const canFiltrar = data.groups.length > 0;
  const showListActions = listadoAlumnos.length > 0 && data.groups.length > 0 && !isLoading;

  const canFilter = isActa ? canFiltrarActa : canFiltrar;
  const canAction = isActa ? canGenerateActa : canImport;

  return (
    <>
      <button
        type="button"
        onClick={handleProceeding}
        disabled={!canFilter || isLoading}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
          fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px', border: 'none',
          backgroundColor: colors.primary, color: '#fff',
          cursor: (!canFilter || isLoading) ? 'not-allowed' : 'pointer',
          opacity: (!canFilter || isLoading) ? 0.5 : 1, transition: 'all 0.15s',
        }}
      >
        {isLoading
          ? <Spinner style={{ height: '13px', width: '13px' }} />
          : <Filter size={13} />}
        Filtrar
      </button>
      <button
        type="button"
        onClick={handleCheck}
        disabled={!showListActions}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
          fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
          border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#6b7280',
          cursor: !showListActions ? 'not-allowed' : 'pointer',
          opacity: !showListActions ? 0.5 : 1, transition: 'all 0.15s',
        }}
      >
        {allChecked ? <Square size={13} /> : <CheckSquare size={13} />}
        {allChecked ? 'Desmarcar' : 'Marcar todos'}
      </button>
      <button
        type="button"
        onClick={isActa ? handleGenerate : handleImport}
        disabled={!canAction}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
          fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
          border: `1px solid ${colors.primary}`, backgroundColor: '#fff',
          color: colors.primary,
          cursor: !canAction ? 'not-allowed' : 'pointer',
          opacity: !canAction ? 0.5 : 1, transition: 'all 0.15s',
        }}
      >
        {isActa ? <FileText size={13} /> : <Download size={13} />}
        {isActa ? 'Generar acta' : importMode === 'ras' ? 'Importar RAs' : 'Importar notas'}
      </button>
    </>
  );
}

AccionesActa.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isActa: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  listadoAlumnos: PropTypes.array.isRequired,
  alumnosIds: PropTypes.array.isRequired,
  activities: PropTypes.array,
  allChecked: PropTypes.bool.isRequired,
  handleProceeding: PropTypes.func.isRequired,
  handleCheck: PropTypes.func.isRequired,
  handleGenerate: PropTypes.func.isRequired,
  handleImport: PropTypes.func.isRequired,
  importMode: PropTypes.string,
  fecha: PropTypes.string,
};

export default AccionesActa;
